module.exports = __webpack_public_path__ + "img/eth_local.b18a9cdb.svg";